import React, { useState } from 'react';
import ScrollEffects from './ScrollEffects';
import Navigation from './sections/Navigation';
import HeroSection from './sections/HeroSection';
import WhatWeDoSection from './sections/WhatWeDoSection';
import ServicesSection from './sections/ServicesSection';
import PricingSection from './sections/PricingSection';
import FreeAuditSection from './sections/FreeAuditSection';
import WhyUsSection from './sections/WhyUsSection';
import AboutSection from './sections/AboutSection';
import CTASection from './sections/CTASection';
import Footer from './sections/Footer';
import { translations } from '../translations/translations';

const LandingPage = () => {
  const [language, setLanguage] = useState('es');
  const t = translations[language];

  return (
    <div className="min-h-screen bg-white" data-testid="landing-page-root">
      <ScrollEffects />
      <Navigation t={t} language={language} setLanguage={setLanguage} />
      <HeroSection t={t} />
      <WhatWeDoSection t={t} />
      <ServicesSection t={t} language={language} />
      <PricingSection t={t} language={language} />
      <FreeAuditSection t={t} />
      <WhyUsSection t={t} />
      <AboutSection t={t} />
      <CTASection t={t} language={language} />
      <Footer t={t} />
    </div>
  );
};

export default LandingPage;
